import script from "./ExcellentQuality.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExcellentQuality.vue?vue&type=script&setup=true&lang=ts"

import "./ExcellentQuality.vue?vue&type=style&index=0&id=45fe6ad2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45fe6ad2"]])

export default __exports__